import { useEffect, useState } from "react";
import { useParams } from "react-router";
import EmployeeNavbar from '../Navbar/EmployeeNavbar'
import ProjectCard from "../../../components/ProjectCard/ProjectCard";
import TaskCard from "../../../components/TaskCard/TaskCard";
import ViewAllButton from "../../../components/buttons/viewAllButton/viewAllButton";
import ProfileCard from "../../../components/EmployeeProfileCard/profileCard";
import MiniTaskCard from "../../../components/miniTaskCard/miniTaskCard";
import RevenueCard from "../../../components/revenueCard/revenueCard";
import ProfileLoader from "../../../components/LoadingComponents/ProfileLoader/ProfileLoader";
import MiniCardLoader from "../../../components/LoadingComponents/miniCardLoader/miniCardLoader";
import RevenueLoader from "../../../components/LoadingComponents/RevenueLoader/RevenueLoader";
import ProjectCardLoader from "../../../components/LoadingComponents/ProjectCardLoader/ProjectCardLoader";
import TaskCardLoader from "../../../components/LoadingComponents/TaskCardLoader/TaskCardLoader";

import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

import style from "./EmployeeDashBoard.module.css";

export default function AdminDashBoard() {

    const [employee, setemployee] = useState({});
    const [projects, setProjects] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [payroll, setPayroll] = useState({});
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('');

    const token = localStorage.getItem("token");
    const { employeeId } = useParams()
    const apiurl = process.env.REACT_APP_SERVER_URL;

    // fetch the employee Full Info
    const GetEmployee = () => {
        return (
            fetch(`${apiurl}/employee-dashboard/${employeeId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            })
                .then((res) => res.json())
                .then((d) => {
                    setemployee(d.user);
                    setLoading(false)
                }
                )
                .catch((err) => {
                    setError(err);
                    setLoading(true)
                })
        )

    }

    // Fetch the employee Assgined Projectss
    const FetchEmployeeProjects = () => {
        return (
            fetch(`${apiurl}/employee/${employeeId}/my-projects`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    setLoading(false)
                    setProjects(data.projects)
                    if (data.length === 0) {
                        setLoading(true)
                        alert("")
                    }
                })
                .catch((err) => {
                    setError(err.message);
                    setLoading(true)
                })
        )
    }

    // Fetch the employee Assgined Projectss
    const FetchEmployeeTasks = () => {
        return (
            fetch(`${apiurl}/employee/${employeeId}/tasks`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    setTasks(Array.isArray(data.tasks) ? data.tasks : []);
                    setLoading(false)
                })
                .catch((err) => {
                    setError(err.message);
                    setLoading(true)
                })
        )
    }

    // fetch the employee Payroll
    const FetchEmployeePayroll = () => {
        return (
            fetch(`${apiurl}/payroll/${employeeId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    setPayroll(data.payroll)
                    setLoading(false)
                })
                .catch((err) => setError(err.message)
                )
        )
    }

    useEffect(() => {
        if (!apiurl) {
            setError('Api is now working')
        }
        GetEmployee();
        FetchEmployeeProjects();
        FetchEmployeeTasks();
        FetchEmployeePayroll();

    }, [apiurl])

    return (
        <>
            <EmployeeNavbar />
            <div className={style.Dashboard}>
                <div className="container mb-3 mb-lg-5 pb-lg-3">

                    {/* error component */}
                    {error && <p className="text-danger">{error}</p>}

                    {/* admin details section start */}
                    <div className={`${style.userDetails} ps-3 ps-lg-3`}>
                        <h6>Hi {employee?.firstName || "User"}</h6>
                        <p className={style.welcomeMsg}>Welcome to Dashboard</p>
                    </div>

                    {/* row layout for Profile loader and profile card */}
                    <div className="row">
                        <div className="col-12 col-sm-12  mb-3 col-md-5 col-lg-5">
                            {loading ?
                                <>
                                    {/* profile Loader Component */}
                                    <ProfileLoader />
                                </>
                                :
                                <>
                                    {/* profile card for employee data */}
                                    <ProfileCard
                                        firstName={employee?.firstName}
                                        lastName={employee?.lastName}
                                        position={employee?.position}
                                        email={employee?.email}
                                        phone={employee?.phonePrimary}
                                        imgAlt={employee?.firstName ? employee?.firstName.charAt(0) : "o"}
                                    />
                                </>
                            }
                        </div>
                        <div className="col-12 col-md-3 col-lg-3">
                            <div className="row">
                                <div className="col-12 mb-3 mb-lg-2">
                                    {loading ?
                                        <>
                                            <MiniCardLoader />
                                        </>
                                        :
                                        <>
                                            <MiniTaskCard
                                                icon={<TaskAltIcon sx={{ fontSize: 30 }} />}
                                                length={projects ? projects?.length : 0}
                                                color={'#008000'}
                                                backgroundColor={'#3DD1781F'}
                                                title="Total Projects"
                                            />
                                        </>
                                    }

                                </div>
                                <div className="col-12 mt-md-2 mb-3 mt-lg-4">
                                    {loading ?
                                        <>
                                            <MiniCardLoader />
                                        </>
                                        :
                                        <>
                                            <MiniTaskCard
                                                icon={<DriveFileRenameOutlineIcon
                                                    sx={{ fontSize: 35 }} />}
                                                length={tasks.length ? tasks.length : 0}
                                                color={'#0000FF'}
                                                backgroundColor={'#17a4ba1f'}
                                                title="Total Tasks"
                                            />
                                        </>
                                    }
                                </div>
                            </div>
                        </div>

                        {/* Revenue card section start */}
                        <div className="col-12  col-md-4 col-lg-4">
                            {loading ?
                                <>
                                    <RevenueLoader />
                                </>
                                :
                                <>
                                    <RevenueCard
                                        revenueAmount={payroll?.baseSalary}
                                        successIcon={<TrendingUpIcon sx={{ fontSize: 35, color: "green" }} />}
                                        FailureIcon={<TrendingDownIcon sx={{ fontSize: 35, color: "red" }} />}
                                    />
                                </>
                            }

                        </div>
                    </div>

                    {/* recents project section */}
                    <div className="row">
                        <div className="d-flex justify-content-between align-items-center  mt-3">
                            <p className={`${style.tabTitle} mb-0 ms-3`}>Recent Projects</p>
                            <ViewAllButton name="view all" path={`/employee-dashboard/${employeeId}/all-projects`} />
                        </div>

                        {/* project card loader and project card  */}
                        {loading ?
                            <>
                                {/* project card loader component */}
                                <div className="col-lg-4">
                                    <ProjectCardLoader />
                                </div>
                                <div className="col-lg-4">
                                    <ProjectCardLoader />
                                </div>
                                <div className="col-lg-4">
                                    <ProjectCardLoader />
                                </div>
                            </>
                            :
                            <>
                                {/* project card  component */}
                                {(projects || []).slice(0, 3).map((project, idx) => (
                                    <div className="col-lg-4 " key={idx}>
                                        <ProjectCard
                                            title={project.title}
                                            team={project.team}
                                            description={project.description}
                                            percentage={90}
                                            link={`/employee-dashboard/${employeeId}/projects/${project._id}`}
                                        />
                                    </div>
                                ))}
                            </>}
                    </div>

                    {/* Tasks Section Start */}
                    <div className="row mt-2">
                        <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                            <p className={`${style.tabTitle} mb-0 ms-2`}>Tasks</p>
                            <ViewAllButton name='view all' path={`/admin-dashboard/${employeeId}/all-tasks`} />
                        </div>

                        {/* recents tasks loader and task card */}
                        {loading ?
                            <>
                                {/* Task card Loader Component */}
                                <TaskCardLoader />
                                <TaskCardLoader />
                                <TaskCardLoader />
                            </>
                            :
                            <>
                                {/* Task card  Component */}
                                {(tasks || []).slice(0, 3).map((task, index) => (
                                    <div className="mb-4 mt-1" key={index}>
                                        <TaskCard
                                            title={task.title}
                                            finishingDate={task.finishingDate}
                                            finishingTime={task.finishingTime}
                                            priority={task.priority}
                                            assignedFor={Array.isArray(task.employeeId) ? task.employeeId.join(", ") : ""}
                                            assignedBy={task.assignedBy}
                                        />
                                    </div>
                                ))}
                            </>
                        }
                    </div>
                </div>
            </div >
        </>
    )
}